// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3a2FV","header":"ClearentDisclaimer_header__2SS9W","inner":"ClearentDisclaimer_inner__1Rpjd"};